import type { WidgetConfig } from '../WidgetCustomization';

export const defaultWidgetConfig: WidgetConfig = {
  primaryColor: "#667eea",
  secondaryColor: "#ff6b6b",
  backgroundColor: "#ffffff",
  textColor: "#333333",
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: "500",
  buttonStyle: "rounded",
  buttonSize: "medium",
  buttonText: "Take a Photo",
  widgetSize: "medium",
  position: "bottom-right",
  title: "Virtual Try-On",
  subtitle: "See how it looks on you",
  callToAction: "Start your virtual fitting",
  showBranding: true,
  enableAR: true,
  enableSharing: false,
  animationType: "fade",
  animationSpeed: "normal",
  uploadButtonText: "Upload a Photo"
};
